// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__Z7EzD","title":"Images45_title__2-J4v","images":"Images45_images__3qz6t"};